<template>
  <div class="logout-btn" :class="{ dark: isMobile }">
    <UiButton
      text
      :dark="isMobile"
      size="small"
      color="secondary"
      @click="logout"
    >
      <svgo-logout class="logout-btn__icon" width="18" height="18" />
      <span>{{ $t('button.logout') }}</span>
    </UiButton>
  </div>
</template>

<script setup>
import useProfileStore from '~/store/profile';

import { STORAGE_AUTH_TOKEN } from '~/constants/cookieStorage';

import { inject } from 'vue';

const { $useApi } = useNuxtApp();
const isMobile = inject('isMobile');

const logout = async () => {
  try {
    await $fetch($useApi.auth.logout, {
      method: 'DELETE',
      headers: useCustomRequestHeaders(),
    });
  } catch (error) {
    console.error(error);
  }

  useProfileStore().resetProfile();
  useCookie(STORAGE_AUTH_TOKEN).value = null;
};
</script>

<style lang="scss">
@use '@/assets/styles/setup/variables.scss' as *;
@use '@/assets/styles/setup/mixins.scss' as *;

.logout-btn {
  position: relative;
  margin-left: 6px;

  @include tablet {
    margin-inline-start: 20px;
  }

  &::before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;

    position: absolute;
    top: 50%;
    left: -11px;
    transform: translate(0, -50%);

    background-color: var(--color-black-56);
    opacity: 0.3;

    @media screen and (max-width: 768px) {
      left: -3px;
    }
  }

  &.dark {
    &::before {
      background-color: var(--color-white-64);
      opacity: 1;
    }
  }

  &.dark &__icon {
    fill: $color-white;
  }

  &__icon {
    fill: $color-1-accent;
  }
}
</style>
